<app-header class="content-header" [small]="true" [class.client-mode]="clientMode">
  @if (allowSidebar) {
    <button
      appButton
      name="toggle-sidebar"
      location="advanced-mode-header"
      [iconButton]="true"
      (click)="toggleHeader()"
      color="gray"
      height="1"
    >
      @if (!showSidebar) {
        <app-svg src="/assets/icons/slide-right.svg"></app-svg>
      } @else {
        <app-svg src="/assets/icons/slide-left.svg"></app-svg>
      }
    </button>
  }
  <form [formGroup]="form">
    <app-input-field
      [control]="form.controls.searchTerm"
      [noLabel]="true"
      [verySmallNoLabel]="true"
      class="super-dark-input headless"
    >
      <app-svg src="/assets/icons/search.svg" *appInputPre></app-svg>
      <input
        type="text"
        formControlName="searchTerm"
        data-test-id="search-input"
        [placeholder]="assets.length === 1 ? 'Search 1 asset' : 'Search ' + assets.length + ' assets'"
        (input)="search()"
        #searchField
      />
    </app-input-field>
  </form>
  <div class="spacer"></div>
  <div class="size-slider" *onlyForScreens="['desktop', 'tablet']">
    <input
      type="range"
      [ngModel]="assetSize()"
      [min]="assetMinSize"
      [max]="assetMaxSize"
      step="10"
      (ngModelChange)="changeAssetSize($event)"
    />
    <label></label>
  </div>
  <app-context-menu [options]="{ width: '240px' }">
    <button
      appButton
      name="sorting-dropdown"
      location="advanced-mode-header"
      [iconButton]="true"
      color="gray"
      height="1"
      class="sorting-button"
      [class.client-mode]="clientMode"
      contextButton
    >
      <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
    </button>
    <div contextContent class="sorting-menu">
      <h3 class="menu-list-title">SORTING</h3>
      @for (sort of sortings; track sort) {
        <div
          class="direction-selection-box"
          [class.selected]="[sort, '-' + sort].includes(sorting)"
          (click)="changeSorting(sort.key)"
        >
          <button
            appButton
            class="sort-button"
            name="sort-{{ sort.key }}"
            location="advanced-mode-header"
            spacing="full"
            alignment="left"
            height="1"
            shape="small"
            [weight]="[sort.key, '-' + sort.key].includes(sorting) ? 'bold' : ''"
            [color]="[sort.key, '-' + sort.key].includes(sorting) ? 'simple-primary' : 'simple'"
          >
            @if (sort.key === 'auto') {
              <span>As Layout</span>
            } @else if (sort.key === 'name') {
              <span>Filename</span>
            } @else if (sort.key === 'created_at') {
              <span>Uploaded</span>
            } @else if (sort.key === 'likes') {
              <span>Favorites</span>
            }

            @if (sort.scope) {
              <app-upgrade-badge
                location="advanced-mode-header"
                [scope]="sort.scope"
                [tenantId]="gallery.tenant?.['id'] || gallery.tenant"
              ></app-upgrade-badge>
            }
          </button>

          @if (!sort.scope || (sort.scope | billingScope)) {
            @if (sort.allowFlip && sorting.endsWith(sort.key)) {
              <button
                appButton
                name="switch-sort-direction"
                location="advanced-mode-header"
                (click)="flipSort(sort.key)"
                color="simple-primary"
                shape="small"
                [iconButton]="true"
                height="1"
                [class.flipped]="sorting === sort.key"
                class="order-button"
              >
                <app-svg src="/assets/icons/arrow-down.svg"></app-svg>
              </button>
            }
          }
        </div>
      }

      <div class="divider"></div>

      <h3 class="menu-list-title">GROUPING</h3>

      @for (group of groupings; track group) {
        <div
          class="direction-selection-box"
          [class.selected]="[group, '-' + group].includes(grouping)"
          (click)="changeGrouping(group.key)"
        >
          <button
            appButton
            class="sort-button"
            name="group-{{ group.key }}"
            location="advanced-mode-header"
            spacing="full"
            alignment="left"
            height="1"
            shape="small"
            [weight]="[group.key, '-' + group.key].includes(grouping) ? 'bold' : ''"
            [color]="[group.key, '-' + group.key].includes(grouping) ? 'simple-primary' : 'simple'"
          >
            @if (group.key === 'selection') {
              <span>Section</span>
            } @else if (group.key === 'likes') {
              <span>Favorites</span>
            } @else if (group.key === 'status') {
              <span>Status</span>
            } @else if (group.key === 'color_label') {
              <span>Color Label</span>
            }

            @if (group.scope) {
              <app-upgrade-badge
                location="advanced-mode-header"
                [scope]="group.scope"
                [tenantId]="gallery.tenant?.['id'] || gallery.tenant"
              ></app-upgrade-badge>
            }
          </button>
        </div>
      }
    </div>
  </app-context-menu>
</app-header>
